import { create } from "zustand";
import axios from "axios";
import { Button, Col, Form, Input, InputNumber, message, Row, Tag } from "antd";

export let useReprice = create((set, get) => ({
    columns: [
        {
            title: 'Maxsulot nomi',
            dataIndex: 'product',
            key: 'product',
            render: (text, record) => (
                <div>
                    <p style={{ color: 'black' }}><b>Product:</b> {record.product_name} <Tag color='red'>{record.sku}</Tag></p>
                    <p style={{ color: 'blue' }}><b>Model:</b> {record.models.map(m=><Tag color='blue' key={m.id}>{m.nameuz}</Tag>)}</p>
                    <p style={{ color: 'green' }}><b>Brand:</b> {record.brands.map(b=><Tag color='green' key={b.id}>{b.nameuz}</Tag>)}</p>
                    <p style={{ color: 'red' }}><b>Davlat:</b> {record.country_name}</p>
                    <p style={{ color: 'indigo' }}><b>Rang:</b> {record.color_name}</p>
                    <p style={{ color: 'brown' }}><b>Ishlab chiqaruvchi:</b> {record.manufacturer_name}</p>
                </div>
            )
        },
        {
            title: 'Narx',
            dataIndex: 'price_uzs',
            key: 'price_uzs',
            render: (text, record) => (
                <>
                    <span><b>Asosiy narx: </b>{record.price_uzs} so'm</span>
                    <br/>
                    <span><b>Chegirmada narxi: </b>{record.dis_uzs} so'm</span>
                </>
            )
        },
        {
            title: 'Yangi narx',
            key: 'new_price_usd',
            render: (text, record) => (
                <Form layout="vertical" initialValues={record} onFinish={(values) => {
                    get().editPrice({
                        id: record.id,
                        price: values.price_usd,
                        dis_price: values.dis_usd,
                    });
                }}>
                    <Row gutter={[16, 16]}>
                        <Col span={8}>
                            <Form.Item name={'price_usd'} label={'Narxi'}>
                                <Input type="number" />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item name={'dis_usd'} label={'Chegirmada narxi'}>
                                <Input type="number" />
                            </Form.Item>
                        </Col>
                        <Col span={8}>
                            <Form.Item label={' '}
                                style={{
                                    textAlign: 'center'
                                }}>
                                <Button type="primary" htmlType="submit">O'zgartirish</Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            )
        },
    ],
    products: [],
    ed: {},
    fetchProducts: async () => {
        try {
            const response = await axios.get('/variations');
            set({ products: response.data });
        } catch (error) {
            console.error('Error fetching products:', error);
        }
    },
    editPrice: async (price) => {
        try {
            const response = await axios.put(`/variations/${price.id}`, price);
            get().fetchProducts();
            message.success('Price updated successfully');
        } catch (error) {
            console.error('Error updating price:', error);
        }
    },
}))